import moment from "moment";

export const convertEpoch = {
  methods: {
    convertEpoch(epochTime) {
      return moment.unix(epochTime).format("dddd, MMMM Do, YYYY");
    }
  }
};
